/**
 * Checks if a given date string is a valid date or not
 *
 * @param {String} dateString Date in String
 *
 * @return {Boolean}
 *
 */
function isValidDateString(dateString) {
    const date = new Date(dateString);
    const isValid = date instanceof Date && !isNaN(date);

    return isValid;
}

export { isValidDateString };
export default {
    isValidDateString,
};
